import angular from 'angular';
import { confirmDialog, alerts } from 'app/components/global';
import {
  ssDialogService,
  orgDataService,
  userService
} from 'app/services';
import editBankLogoDialog from '../editLogoDialog';
import controller from './edit-customer-azure.directive.controller';
import directive from './edit-customer-azure.directive';


export default angular.module('app.components.admin.customerAdministration.editCustomerAzure', [
  alerts,
  confirmDialog,
  orgDataService,
  ssDialogService,
  userService,
  editBankLogoDialog
])
  .directive('caEditCustomerAzure', directive)
  .controller('CAEditCustomerAzureDirectiveController', controller)
  .name;

console.log('app.components.admin.customerAdministration.editCustomerAzure created');
